import { generateRandomString } from "../../utils/generateRandomString";

export const generateWidgetId = () => {
  return "sv_" + generateRandomString();
};

export const defaultSmartViewWidgetSize = {
  width: 10,
  height: 20,
};

export const defaultFilterWidgetSize = {
  width: 10,
  height: 10,
};
